import React from 'react';
import { Input } from "@shadcn-in-nx/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";

export function TimeInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSave(value);
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  const getLocalFormattedValue = (val) => {
    if (!val) return '';
    // Extract "hh:mm" or "hh:mm:ss" from "hh:mm:ssZ"
    const match = String(val).match(/^(\d{2}:\d{2}(:\d{2})?)/);
    if (match) {
      return match[1];
    }
    return val;
  };

  const formattedValue = getLocalFormattedValue(value);

  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    if (!rawValue) {
      onChange(null);
    } else {
      // AJV "time" format strict RFC 3339 requirements: needs seconds and timezone
      let formatted = rawValue;
      if (formatted.length === 5) {
        formatted += ':00'; // Append seconds if missing
      }
      // Assuming UTC since 'time' fields usually don't carry contextual offset from html input
      if (!formatted.endsWith('Z') && !formatted.includes('+') && !formatted.includes('-') && formatted.length >= 8) {
        formatted += 'Z';
      }
      onChange(formatted);
    }
  };

  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  return (
    <div className='w-full h-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Input
                type="time"
                step="1" // Provides second support, use "any" for ms, or default (1 min) if omitted. Usually schema "time" supports seconds.
                value={formattedValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onBlur={() => onSave(value)}
                autoFocus={autoFocus}
                min={schema?.minimum}
                max={schema?.maximum}
                className={errorClass}
              />
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
